var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{style:('font-weight:bold;'+(_vm.window.width<480 ? 'font-size:10px;': 'font-size:12px;'))},[_vm._v("\r\n    "+_vm._s(_vm.$tc(
        "sondage.nbReponses_au_sondage",
        this.$store.state.sondage.nbr_reponses_au_sondage,
        { count: this.$store.state.sondage.nbr_reponses_au_sondage }
      ))+"\r\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ed1990","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultats/components/NbParticipants.vue
// module id = null
// module chunks = 